import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { restoreSwitchUserAdminSession, SWITCH_USER_ADMIN_TOKEN_KEY } from './switch-user.service';

/**
 * TVG-379: set on calls whose 401 means "this link is no good" rather than
 * "your session has ended" (the public quote-link redeem). Without it a stale
 * quote link signed the admin who opened it out of their own session.
 */
export const SKIP_SESSION_EXPIRY = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');
  const router = inject(Router);

  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  const skipSessionExpiry = req.context.get(SKIP_SESSION_EXPIRY);

  return next(req).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse && !skipSessionExpiry) {
        if (err.status === 401 && localStorage.getItem(SWITCH_USER_ADMIN_TOKEN_KEY)) {
          // TVG-378: the switched session has ended (revoked elsewhere), so
          // fall back to the admin's own session rather than the login page.
          restoreSwitchUserAdminSession();
        } else if (err.status === 401) {
          localStorage.removeItem('token');
          router.navigate(['/login']);
        } else if (err.status === 403) {
          router.navigate(['/error'], { queryParams: { code: 403 } });
        } else {
          throw err;
        }
      }
      throw err;
    }),
  );
};
